<template>
  <el-progress
    :text-inside="true"
    :stroke-width="18"
    :percentage="percentage"
    :status="saveStatus">
  </el-progress>
</template>

<script>
  export default {
    props: {
      totalRequests: { type: Number, default: 0 },
      completedRequests: { type: Number, default: 0 },
      error: { type: Boolean, default: false }
    },
    computed: {
      percentage () {
        if (this.totalRequests) {
          return Math.ceil((this.completedRequests / this.totalRequests) * 100)
        }
        return 0
      },
      saveStatus () {
        if (this.percentage === 100) {
          return 'success'
        } else if (this.percentage !== 100 && this.error) {
          return 'exception'
        }
        return null
      }
    }
  }
</script>
